module.exports = __webpack_public_path__ + "static/img/loading_ho.744615c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading_ho.jpg
// module id = RyMi
// module chunks = 1